import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ImageUrlPipe } from '../../pipe/image-url.pipe';

export interface SliderItem {
  id?: number | string;
  title: string;
  description: string;
  link: string;
  imageUrl: string;
  imageFile?: File;
  languageCode: string;
}

interface Language { code: string; flag: string; }

@Component({
  standalone: true,
  selector: 'app-sliders-management',
  imports: [CommonModule, FormsModule,ImageUrlPipe],
  templateUrl: './sliders-management.component.html',
  styleUrls: ['./sliders-management.component.scss']
})
export class SlidersManagementComponent implements OnInit {

  // ── State ──────────────────────────────────────────────
  items: SliderItem[] = [];
  showModal        = false;
  showDeleteConfirm = false;
  saving           = false;
  editingItem: SliderItem | null = null;
  deletingItem: SliderItem | null = null;
  imagePreview: string | null = null;

  // ── Languages ──────────────────────────────────────────
  languages: Language[] = [
    { code: 'en', flag: '🇺🇸' },
    { code: 'ar', flag: '🇸🇦' },
    { code: 'fr', flag: '🇫🇷' },
    { code: 'de', flag: '🇩🇪' },
    { code: 'es', flag: '🇪🇸' },
    { code: 'tr', flag: '🇹🇷' },
  ];

  // ── Form ──────────────────────────────────────────────
  form: SliderItem = this.emptyForm();

  private emptyForm(): SliderItem {
    return { title: '', description: '', link: '', imageUrl: '', languageCode: 'en' };
  }

  // ── Lifecycle ─────────────────────────────────────────
  ngOnInit(): void {
    this.loadItems();
  }

  loadItems(): void {
    // TODO: replace with real service call
    // this.sliderService.getAll().subscribe(data => this.items = data);
    this.items = [
      { id: 1, title: 'Summer Collection', description: 'Explore the latest arrivals', link: 'https://example.com', imageUrl: 'https://picsum.photos/seed/s1/800/400', languageCode: 'en' },
      { id: 2, title: 'عروض الصيف', description: 'اكتشف أحدث المنتجات', link: 'https://example.com', imageUrl: 'https://picsum.photos/seed/s2/800/400', languageCode: 'ar' },
    ];
  }

  // ── Modal ─────────────────────────────────────────────
  openModal(item?: SliderItem): void {
    this.editingItem  = item ?? null;
    this.form         = item ? { ...item } : this.emptyForm();
    this.imagePreview = item?.imageUrl || null;
    this.showModal    = true;
  }

  closeModal(): void {
    this.showModal    = false;
    this.editingItem  = null;
    this.imagePreview = null;
    this.form         = this.emptyForm();
  }

  // ── Image ─────────────────────────────────────────────
  onImageSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    this.form.imageFile = file;
    const reader = new FileReader();
    reader.onload = e => this.imagePreview = e.target?.result as string;
    reader.readAsDataURL(file);
  }

  removeImage(): void {
    this.imagePreview  = null;
    this.form.imageUrl = '';
    this.form.imageFile = undefined;
  }

  // ── Save ──────────────────────────────────────────────
  saveItem(): void {
    if (!this.form.languageCode) return;
    this.saving = true;

    // TODO: replace with real service call
    // const formData = new FormData();
    // Object.entries(this.form).forEach(([k, v]) => { if (v) formData.append(k, v as any); });
    // const call$ = this.editingItem
    //   ? this.sliderService.update(this.editingItem.id!, formData)
    //   : this.sliderService.create(formData);
    // call$.subscribe({ next: () => { this.loadItems(); this.closeModal(); this.saving = false; },
    //                   error: () => { this.saving = false; } });

    // Mock
    setTimeout(() => {
      if (this.imagePreview) this.form.imageUrl = this.imagePreview;

      if (this.editingItem) {
        const idx = this.items.findIndex(i => i.id === this.editingItem!.id);
        if (idx > -1) this.items[idx] = { ...this.form, id: this.editingItem.id };
      } else {
        this.items = [{ ...this.form, id: Date.now() }, ...this.items];
      }

      this.saving = false;
      this.closeModal();
    }, 800);
  }

  // ── Delete ────────────────────────────────────────────
  confirmDelete(item: SliderItem): void {
    this.deletingItem     = item;
    this.showDeleteConfirm = true;
  }

  deleteItem(): void {
    if (!this.deletingItem) return;

    // TODO: replace with real service call
    // this.sliderService.delete(this.deletingItem.id!).subscribe(() => this.loadItems());

    this.items = this.items.filter(i => i.id !== this.deletingItem!.id);
    this.deletingItem      = null;
    this.showDeleteConfirm = false;
  }
}